import { useGenerateEventPDF } from '~/event-panel/event-api/use-generate-event-pdf';
import { useEnabledFeatures } from '~/common/hooks/enabled-features';
import { useAttachments } from '~/attachments/hooks/use-attachments';
import { ExportButton } from '~/common/components/export/export-button';
import { useCallback } from 'react';

interface EventExportButtonProps {
    eventId: number;
    eventNumber: string;
}

export function EventExportButton({ eventId, eventNumber }: EventExportButtonProps) {
    const {
        generatePDFWithoutAttachments,
        generatePDFWithAttachments,
        isLoading,
    } = useGenerateEventPDF();
    const { mediaAttachmentsEnabled } = useEnabledFeatures();
    const { data } = useAttachments({
        entityId: eventId,
        entityType: 'CAD_AGENCY_EVENT',
    });

    const hasAttachments = mediaAttachmentsEnabled && (data?.attachments?.length ?? 0) > 0;

    const handleExportPDF = useCallback(() => {
        generatePDFWithoutAttachments(eventId, eventNumber);
    }, [generatePDFWithoutAttachments, eventId, eventNumber]);

    const handleExportPDFWithAttachments = useCallback(() => {
        generatePDFWithAttachments(eventId, eventNumber);
    }, [generatePDFWithAttachments, eventId, eventNumber]);

    return (
        <ExportButton
            hasAttachments={hasAttachments}
            isLoading={isLoading}
            onExportPDF={handleExportPDF}
            onExportPDFWithAttachments={handleExportPDFWithAttachments}
        />
    );
}
